<template>
  <v-app>
    <site-header v-if="User"></site-header>
    <div v-else></div>
    <v-main>
      <router-view/>
    </v-main>

    <v-dialog
      v-model="isApprove"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">사업자 등록 중 입니다.</span>
        </v-card-title>
        <v-card-text
          class="pa-0"
        >
          <v-container>
            <v-timeline
              align-top
              dense
            >
              <v-timeline-item
                color="teal lighten-3"
                small
              >
                <v-row class="pt-1">
                  <v-col>
                    <strong>회원 가입</strong>
                  </v-col>
                </v-row>
              </v-timeline-item>

              <v-timeline-item
                color="teal lighten-3"
                small
              >
                <v-row class="pt-1">
                  <v-col>
                    <strong>사업자 등록증 업로드</strong>
                  </v-col>
                </v-row>
              </v-timeline-item>

              <v-timeline-item
                color="pink"
                small
              >
                <v-row class="pt-1">
                  <v-col>
                    <strong>승인 대기중</strong>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-container>
          <small
            class="pa-3"
          >
            *승인 처리가 되면 사용 가능합니다.
          </small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="goHome"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isLicense"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">사업자 등록증 업로드</span>
        </v-card-title>
        <v-card-text
          class="pa-0"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <div
                  v-if="!filepath"
                >
                  <v-file-input
                    v-model="thumbImage"
                    :rules="thumbRules"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="사진 선택하기"
                    prepend-icon="mdi-camera"
                    label="사업자 등록증"
                    @change="imageUpload"
                    ref="files"
                  ></v-file-input>
                </div>
                <div
                  v-else
                >
                  <v-card>
                    <v-img
                      :src="filepath"
                    >
                      <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="white"
                          icon
                          @click="filepath = null"
                        >
                          <v-icon>
                            mdi-close-box
                          </v-icon>
                        </v-btn>
                      </v-app-bar>
                    </v-img>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <small
            class="pa-3"
          >
            *사업자 등록증 등록 후 승인 처리가 되면 사용 가능합니다.
          </small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="uploadLicense"
          >
            등록
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

// For 카카오톡 푸시
<script src="https://developers.kakao.com/sdk/js/kakao.mim.js"></script>

<script>
import SiteHeader from '@/components/Header'

export default {
  name: 'App',

  components: {
    SiteHeader
  },

  data () {
    return {
      User: null,
      isLicense: false,
      isApprove: false,
      filepath: '',
      thumbImage: null,
      thumbRules: [
        value => !value || value.size < 2000000 || '이미지 크기는 2 MB 이하로 제한됩니다!'
      ]
    }
  },

  created () {
  },

  mounted () {
    this.checkingLogin()
  },

  updated () {
    this.User = this.$firebase.auth().currentUser
    this.checkingLicense()
  },

  methods: {
    checkingLogin () {
      if (!this.User) {
        alert('세션이 만료되었습니다. 다시 로그인해주세요.')
        this.$router.replace('login')
      }
    },

    checkingLicense () {
      var _this = this

      if (_this.User) {
        var userID = _this.User.uid

        _this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
          if (snapshot.empty) {
            return
          }

          _this.isLicense = true
          _this.isApprove = false

          if (snapshot.val() && snapshot.val().license) {
            _this.isLicense = false
          }

          if (snapshot.val().level === 4) {
            _this.isApprove = true
          }
        })
      } else {
        _this.isLicense = false
        _this.isApprove = false
      }
    },

    uploadLicense () {
      var _this = this

      var userID = this.$firebase.auth().currentUser.uid

      var updateDatas = {}

      updateDatas['users/' + userID + '/license'] = _this.filepath
      updateDatas['users/' + userID + '/level'] = 4
      _this.isApprove = true

      this.$firebase.database().ref().update(
        updateDatas,
        function (error) {
          if (error) {
            console.log(error)
          } else {
            _this.isLicense = false
            console.log('사업자 등록증 업로드 완료')
          }
        }
      )
    },

    async imageUpload () {
      var _this = this

      var userID = this.$firebase.auth().currentUser.uid

      var storageRef = _this.$firebase.storage().ref()

      var file = _this.thumbImage

      var metadata = {
        contentType: 'image/jpeg'
      }

      var uploadTask = storageRef.child('images/license/' + userID + '/' + file.name).put(file, metadata)

      await uploadTask.on('state_changed',
        function (snapshot) {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100

          console.log(progress + '%')

          switch (snapshot.state) {
            case 'paused':
              break
            case 'running':
              break
          }
        }, function (error) {
          console.log(error)
        }, function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            _this.filepath = downloadURL
          })
        }
      )
    },

    goHome () {
      var _this = this

      _this.$firebase.auth().signOut().then(
        function () {
          _this.isApprove = false
          _this.$router.push('/')
        }
      )
    }
  }
}
</script>
